module.exports = __webpack_public_path__ + "img/payfort1.e40d57d3.png";